import { useContext } from 'react';
import {
  mapUpdates,
  mapHeaderContents,
  mapHeaderContentsForSearch,
  mapAdditionalToolsContents,
  mapAdditionaToolsForSearch,
} from '../helpers';
import { LagoonContext } from '../LagoonContext';

// This is Provider Portal Dashboard Lagoon hook.
// Each function will be labeled with how to consume.

export const usePPDLagoon = () => {
  const { ppdLagoonTables } = useContext(LagoonContext);

  // consume: getAdditionalToolsContents()
  const getAdditionalToolsContents = () => {
    return mapAdditionalToolsContents(
      ppdLagoonTables.additionalToolsContentsArray
    );
  };

  // consume: getAdditionalToolsContentsByKey()
  const getAdditionalToolsContentsByKey = (key) => {
    return ppdLagoonTables.additionalToolsContentsObject[key];
  };

  // consume: getAdditionalToolsContentsBySection()
  const getAdditionalToolsContentsBySection = () => {
    return mapAdditionalToolsContents(
      ppdLagoonTables.additionalToolsContentsArray
    );
  };

  // consume: getAdditionalToolsForSearch()
  const getAdditionalToolsForSearch = () => {
    return mapAdditionaToolsForSearch(
      ppdLagoonTables.additionalToolsContentsArray
    );
  };

  const getAssetByKey = (key) => {
    return ppdLagoonTables.assets[key];
  };

  // consume: getFeature('AARP_PROVIDER_ONLNE_TOOL_LINK')
  const getFeature = (featureFlagKey) => {
    if (ppdLagoonTables.featureFlags[featureFlagKey]) {
      return ppdLagoonTables.featureFlags[featureFlagKey];
    }
    return false;
  };

  // consume: getHomePageContentByKey('toolResources')
  const getHomePageContentByKey = (contentKey) => {
    return ppdLagoonTables.homePageContents[contentKey];
  };

  // consume: getHomepageContentByArrayOfKeys(['example', 'example2'])
  const getHomePageContentsByArrayOfKeys = (arrayOfKeys) => {
    const tempArray = [];
    arrayOfKeys.forEach((key) => {
      tempArray.push(ppdLagoonTables.homePageContents[key]);
    });
    return ppdLagoonTables.homePageContents ? tempArray : [];
  };

  // header-contents
  const getHeaderContentByKey = (contentKey) => {
    return ppdLagoonTables.headerContentsByKey[contentKey];
  };

  const getHeaderContents = (menu, dropdown) => {
    return mapHeaderContents(
      ppdLagoonTables.headerContentsInArray,
      menu,
      dropdown
    );
  };

  const getHeaderContentsByArrayOfKeys = (arrayOfKeys) => {
    const tempArray = [];
    arrayOfKeys.forEach((key) => {
      tempArray.push(ppdLagoonTables.headerContentsByKey[key]);
    });

    return ppdLagoonTables.headerContentsByKey ? tempArray : [];
  };

  const getHeaderContentsForSearch = () => {
    return mapHeaderContentsForSearch(ppdLagoonTables.headerContentsInArray);
  };

  const getErrorMessage = (key) => {
    return ppdLagoonTables.errorMessages[key];
  };

  // consume: getMessage("UHC_UPDATES_DATE")
  const getMessage = (key) => {
    return ppdLagoonTables.uiMessages[key];
  };

  // consume: uhcUpdates('left')
  const getUhcUpdates = (position) => {
    return mapUpdates(ppdLagoonTables.uhcUpdates, position);
  };

  return {
    getAdditionalToolsContents,
    getAdditionalToolsContentsByKey,
    getAdditionalToolsContentsBySection,
    getAdditionalToolsForSearch,
    getAssetByKey,
    getErrorMessage,
    getFeature,
    getHeaderContentByKey,
    getHeaderContents,
    getHeaderContentsByArrayOfKeys,
    getHeaderContentsForSearch,
    getHomePageContentByKey,
    getHomePageContentsByArrayOfKeys,
    getMessage,
    getUhcUpdates,
  };
};
